<div class="flex flex-col">

  <div *ngIf="!managingOwner" class="flex flex-col md:flex-row gap-2 items-center">
    <span class="font-semibold">Entity</span>
    <span class="font-semibold">Owners</span>

    <div class="flex flex-col md:flex-row gap-4 ml-4">
    <button type="button" *ngIf="(!managingOwner && !isSubunit && !locked && !renewal) || isChange"
            mat-button color="primary" (click)="createOwner()">Add an Owner</button>

    <button type="button" *ngIf="canChange && !managingOwner && !isSubunit && approved || (!isSubunit && canChange && renewal)"
      mat-button color="primary" (click)="routeChangeRequest(0, sharedService.add)">Add an Owner</button>

    <button type="button" *ngIf="canChange && !managingOwner && approved || (canChange && renewal)"
      mat-button color="primary" (click)="routeChangeRequest(0, sharedService.change)">Change Owner</button>

    <button type="button" *ngIf="!managingOwner && !isChange"
      mat-button color="primary" (click)="getOwners(!includeArchived)">{{includeArchived? 'Hide Archived' : 'Show Archived'}}</button>
    </div>
  </div>

  <div class="flex flex-col gap-4" *ngIf="isOutOfState && entityType !== sharedService.hospitalLicense" [@slideRight]>
    <span class="font-semibold">Owners who reside outside of Oregon must have fingerprints taken.</span>
    <button type="button"  class="portal-text-action" (click)="downloadReferenceDocument(sharedService.fingerprints)">
      Download Fingerprint Instructions
    </button>
  </div>

  <div class="flex flex-wrap" *ngIf="!managingOwner" [@slideRight]>
    <div class="md:p-2" [ngClass]="isChange? 'w-full': 'md:w-1/2'" *ngFor="let owner of owners">
      <mat-card>
        <mat-card-content>
          <div class="flex flex-col">
            <div class="flex flex-col md:flex-row gap-2 md:items-center" [ngClass]="isSubunit? '' : '-mt-4'">
              <div class="flex flex-col md:flex-row gap-2 font-semibold text-lg">
                <span>{{ owner.firstName }}</span>
              </div>

              <div class="flex flex-col md:flex-row justify-self-end items-center ml-auto" *ngIf="(!locked && !renewal) || isSubunit">
                <span class="font-semibold" *ngIf="owner.archived">Archived</span>

                <button *ngIf="!isSubunit" type="button" mat-button color="warn" (click)="confirmDelete(owner.id)">Delete</button>

                <button *ngIf="!isSubunit && !isChange" type="button" mat-icon-button [color]="owner.archived? 'primary' : 'warn'"
                        (click)="archiveOwner(owner, !owner.archived)" [matTooltip]="owner.archived? 'Un-Archive Owner' : 'Archive Owner'"
                        matTooltipShowDelay="500" matTooltipHideDelay="200">
                  <mat-icon [fontIcon]="owner.archived? 'unarchive' : 'archive'"></mat-icon>
                </button>
              </div>

              <div class="flex flex-col md:flex-row justify-self-end items-center ml-auto" *ngIf="(locked || renewal) && !isSubunit">
                <span class="font-semibold" *ngIf="owner.archived">Archived</span>

                <button type="button" mat-button color="primary" *ngIf="!isSubunit" (click)="selectOwner(owner)">Edit</button>

                <button *ngIf="canChange && !owner.archived && approved || (canChange && renewal)" type="button" mat-button color="warn"
                  (click)="routeChangeRequest(owner.id, sharedService.delete)">Request to Remove</button>
              </div>
            </div>

            <div class="flex flex-col gap-4">
              <div class="flex flex-col md:flex-row gap-4">
                <div class="flex flex-col md:w-1/3">
                  <div class="flex flex-row">
                    <span class="md:w-1/3">Phone:</span>
                    <span>{{ owner.phone | mask:'000-000-0000' }}</span>
                  </div>
                  <div class="flex flex-row">
                    <span class="md:w-1/3">Fax:</span>
                    <span>{{ owner.fax | mask:'000-000-0000' }}</span>
                  </div>
                </div>

                <div class="flex flex-col md:w-1/3">
                  <div class="flex flex-row">
                    <span class="md:w-1/2">Tax ID:</span>
                    <span>{{ owner.taxId }}</span>
                  </div>
                  <div class="flex flex-row" *ngIf="entityType !== sharedService.hospitalLicense">
                    <span class="md:w-1/2">Client Contact:</span>
                    <span>{{ owner.contactWithClient? 'Yes' : 'No' }}</span>
                  </div>
                </div>
              </div>

              <div class="flex flex-col gap-4">
                <address [entityId]="owner.id"
                         [entityType]="sharedService.entityOwner"
                         [limitEntries]="true"
                         [canEdit]="false"
                         (reportOutOfState)="updateOutOfState($event)"></address>

                <document *ngIf="owner.contactWithClient && entityType !== sharedService.hospitalLicense"
                          [entityId]="owner.id"
                          [entityType]="sharedService.entityOwner"
                          [editable]="true"></document>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>

  <div class="flex flex-col" *ngIf="managingOwner" [@slideRight]>
    <form [formGroup]="ownerForm">
      <div class="flex flex-col">

        <div class="flex flex-col md:flex-row gap-8 items-start">
          <div class="flex flex-col">
            <div class="flex flex-col md:flex-row gap-4 items-center">
              <div>
                <div *ngIf="managingOwner && owner.id === 0" class="flex flex-col md:flex-row gap-1">
                  <span class="font-semibold">Add</span>
                  <span class="font-semibold">Owner</span>
                </div>
                <div *ngIf="managingOwner && owner.id > 0" class="flex flex-col md:flex-row gap-1">
                  <span class="font-semibold">Update</span>
                  <span class="font-semibold">Owner</span>
                </div>
              </div>
              <div class="gap-2 flex justify-self-end items-center">
                <button type="button" *ngIf="managingOwner && ownerForm.valid"
                        mat-button color="primary" (click)="saveOwner()">Save</button>
                <button type="button" *ngIf="managingOwner"
                        mat-button color="warn" (click)="toggleOwnerForm(false)">Close</button>
              </div>
            </div>

            <div class="flex flex-col items-start pt-4" [ngClass]="!isChange? 'md:flex-row gap-4 ' : ''">
              <div class="flex flex-col" [ngClass]="!isChange? 'md:flex-row md:w-1/3 gap-4' : ''">
                <div class="flex flex-col">
                  <div class="flex flex-col md:flex-row md:gap-2">
                    <mat-form-field [ngClass]="!isChange? 'w-full' : 'w-1/2'">
                      <mat-label>Owner Name</mat-label>
                      <input matInput formControlName="firstName">
                      <mat-error *ngIf="ownerForm.get('firstName')?.hasError('required')">
                        The owner name is required
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col md:flex-row md:gap-2">
                    <mat-form-field>
                      <mat-label>Phone</mat-label>
                      <input matInput formControlName="phone" mask="000-000-0000">
                      <mat-error *ngIf="ownerForm.get('phone')?.hasError('required')">
                        A phone number is required
                      </mat-error>
                      <mat-error *ngIf="ownerForm.get('phone')?.hasError('pattern')">
                        Phone should match format: 000-000-0000
                      </mat-error>
                    </mat-form-field>

                    <mat-form-field>
                      <mat-label>Fax</mat-label>
                      <input matInput formControlName="fax" mask="000-000-0000">
                      <mat-error *ngIf="ownerForm.get('fax')?.hasError('pattern')">
                        Fax should match format: 000-000-0000
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="flex flex-col gap-2 md:w-1/2">
                    <mat-form-field>
                      <mat-label>Tax ID</mat-label>
                      <input matInput formControlName="taxId">
                    </mat-form-field>
                  </div>
                </div>

                <div class="flex flex-col" *ngIf="entityType !== sharedService.hospitalLicense">
                  <div class="flex flex-col gap-2">
                    <label id="owner-client-contact">
                      Does the owner have direct contact with any client as defined in OAR 333-536-0093?
                      (If yes, attach 'Background Check Request'.)
                    </label>
                    <mat-radio-group aria-labelledby="admin-client-contact" formControlName="contactWithClient">
                      <mat-radio-button [value]="true">
                        Yes
                      </mat-radio-button>
                      <mat-radio-button [value]="false">
                        No
                      </mat-radio-button>
                    </mat-radio-group>
                    <button type="button"  *ngIf="ownerForm.get('contactWithClient')?.value"
                          class="portal-text-action"
                          [@slideRight]
                          (click)="downloadReferenceDocument(sharedService.emptyBackgroundCheck)">
                      Download Background Check Request Form
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div [ngClass]="!isChange? 'md:w-1/2' : ''">
            <address [entityId]="owner.id"
                    [entityType]="sharedService.entityOwner"
                    [limitEntries]="true"
                    [canEdit]="true"
                    (reportOutOfState)="updateOutOfState($event)"></address>
            <div class="flex flex-col gap-4" *ngIf="isOutOfState && entityType !== sharedService.hospitalLicense" [@slideRight]>
              <span class="font-semibold">Owners who reside outside of Oregon must have fingerprints taken.</span>
              <button type="button"  class="portal-text-action" (click)="downloadReferenceDocument(sharedService.fingerprints)">
                Download Fingerprint Instructions
              </button>
            </div>
          </div>

        </div>

        <document *ngIf="ownerForm.get('contactWithClient')?.value && entityType !== sharedService.hospitalLicense"
                  [ngClass]="!isChange? 'md:w-1/2' : ''"
                  [@slideRight]
                  [entityId]="owner.id"
                  [entityType]="sharedService.entityOwner"
                  [statuses]="statuses"
                  [types]="entityOwnerDocTypes"></document>
        <div class="flex flex-row pt-2">
          <button class="ml-auto" type="button" *ngIf="managingOwner && ownerForm.valid && isChange"
                  mat-button color="primary"
                  (click)="saveOwner()">Save Owner Info</button>
        </div>
      </div>
    </form>
  </div>
